
import React from 'react';
import HistoryTable from '../History/HistoryTable';
const SendHistory = ({ userID, collectionName }) => {
  const columns = [
    { key: 'date', label: 'Date & Time' },
    { key: 'amount', label: 'Amount' },
    { key: 'receiverId', label: 'To (Receiver ID)' },
  ];

  return (
    <HistoryTable
      userID={userID}
      collectionName={collectionName}
      historyType="sendHistory"
      title="Send History"
      columns={columns}
      searchField="receiverId"
    />
  );
};

export default SendHistory;